const STORAGE_KEY = "auth.loginRedirectAt";

/** A return to login inside this window is treated as a redirect loop. */
export const AUTH_REDIRECT_LOOP_WINDOW_MS = 20_000;

const readStorage = (): Storage | null => {
  try {
    return window.localStorage;
  } catch {
    return null;
  }
};

export const markAuthRedirect = (now = Date.now()): void => {
  try {
    readStorage()?.setItem(STORAGE_KEY, String(now));
  } catch {
    // Private mode and storage partitions can reject writes.
  }
};

export const clearAuthRedirectMark = (): void => {
  try {
    readStorage()?.removeItem(STORAGE_KEY);
  } catch {
    // Ignore storage failures; the next login attempt still works.
  }
};

export const isAuthRedirectLooping = (now = Date.now()): boolean => {
  try {
    const raw = readStorage()?.getItem(STORAGE_KEY);
    const at = raw ? Number(raw) : Number.NaN;
    return Number.isFinite(at) && now - at >= 0 && now - at < AUTH_REDIRECT_LOOP_WINDOW_MS;
  } catch {
    return false;
  }
};

/**
 * iOS Safari treats an immediate cross-site redirect as bounce tracking and
 * drops the PKCE state written just before navigation. A tap counts as a
 * user gesture, so the round trip keeps localStorage.
 */
export const prefersUserGestureSignIn = (): boolean => {
  if (typeof navigator === "undefined") {
    return false;
  }

  const ua = navigator.userAgent || "";
  if (/iPhone|iPad|iPod/.test(ua)) {
    return true;
  }

  return navigator.platform === "MacIntel" && navigator.maxTouchPoints > 1;
};
